exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".countdownView{font-size:10em}.viewer{height:100vh;margin:0;padding:0}\n", ""]);

